import { render, staticRenderFns } from "./multidamagePcForm.pug?vue&type=template&id=568f2022&lang=pug&external"
import script from "./multidamagePcForm.js?vue&type=script&lang=js&external"
export * from "./multidamagePcForm.js?vue&type=script&lang=js&external"
import style0 from "./multidamagePcForm.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568f2022')) {
      api.createRecord('568f2022', component.options)
    } else {
      api.reload('568f2022', component.options)
    }
    module.hot.accept("./multidamagePcForm.pug?vue&type=template&id=568f2022&lang=pug&external", function () {
      api.rerender('568f2022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/multidamagePcForm/index.vue"
export default component.exports